import { PermissionType } from './enum/PERMISSION';

export class UserPermission {
  application: string;
  role: string;
  permissions: Array<PermissionType>;
}
